import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { logging } from '../../actions/log';
import {
  aigcReplyCommandEnd,
  aigcGetQuestion,
  aigcReplyListAddReply,
  aigcReplyIsBusing,
} from '../../actions/aigc';
// import { aigcAddDownload, aigcShowMessage } from '../../../actions/aigc';
import { PCStoreJsBridge } from '../../nativeapi';
import { downloadAddSoft } from '../../actions/downloadTask';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectAIGCReplys = createSelector(
  state => state.aigc,
  aigc => aigc,
);

let AIGC_CommandEnd_timeID = {};
let AIGC_CommandEnd_LogInfo_timeID = {};
export default memo(({}) => {
  const dispatch = useDispatch();
  const { aigcReplys, aigcRecoQuestion } = useSelector(selectAIGCReplys); // AI当前回答

  const logInfoData = useSelector(selectLogInfo);
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装

  const sortOrder = {
    '-2': 1,
    '-1': 2,
    0: 3,
    5: 4,
    6: 5,
    7: 6,
    8: 7,
    1: 8,
    2: 9,
    3: 10,
    4: 11,
  };
  const sotAigcReplys = (replys = []) => {
    let replysList = [...replys];
    replysList.sort((a, b) => {
      return sortOrder[a.commandCode] - sortOrder[b.commandCode];
    });
    return replysList;
  };
  /**
   * 处理指令的下载任务
   */
  useEffect(() => {
    if (
      aigcReplys &&
      aigcReplys?.replys &&
      aigcReplys?.replys?.length > 0 &&
      aigcReplys?.timeId &&
      aigcReplys?.chatType === 'reply' &&
      aigcReplys?.isReAnswer === false &&
      !AIGC_CommandEnd_timeID[aigcReplys?.timeId]
    ) {
      let h5IDAll = +new Date();
      let aigcReplysArr = sotAigcReplys(aigcReplys?.replys || []);
      aigcReplysArr.forEach((item, i) => {
        if (['-2', '-1', '0', '1', '2', '3', '4'].indexOf(item.commandCode) > -1) {
          let h5ID = +new Date() + i;
          let writing = 2; // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
          let newReply = {
            h5IDAll: h5IDAll, //
            chatType: 'reply',
            userQuestion: aigcReplys.userQuestion,
            replys: [
              {
                ...item,
                h5ID: h5ID, //
                writing: writing,
                context: aigcReplys.context,
                question: aigcReplys.question,
              },
            ],
          };
          dispatch(aigcReplyListAddReply(newReply));
        }
        if (item.commandCode === '5') {
          if (item?.commandMsg?.appList && item?.commandMsg?.appList?.length > 0) {
            let textInfoArr = [''];
            let softArr = [];
            let errorApplist = [];
            item.commandMsg.appList.forEach(soft => {
              let flag = handleInstallSoft(soft);
              //11: 正常可以下载   2: 正在任务中  3:已安装  4:可更新  5:不支持下载  0:错误
              if (flag === 1 || flag === 4) {
                textInfoArr.push(`${soft.softName} 已为您添加到下载任务中。`);
                softArr.push(soft);
              }
              if (flag === 2) {
                textInfoArr.push(`检测到 ${soft.softName} 已在下载任务中。`);
                softArr.push(soft);
              }
              if (flag === 3) {
                textInfoArr.push(`您似乎已经安装了 ${soft.softName} 应用。`);
              }
              if (flag === 5) {
                softArr.push(soft);
                errorApplist.push(soft);
                // textInfoArr.push(`${soft.softName} 不支持直接下载安装。`);
              }
            });

            let textInfo = textInfoArr.join('');
            let isShowTask = 1;
            if (softArr?.length === 0) {
              isShowTask = 0;
            }
            dispatch(aigcReplyIsBusing({ isBusing: 1 }));
            dispatch(
              aigcReplyCommandEnd({
                ...aigcReplys,
                isCommandEnd: true,
                textInfo,
                isShowTask: isShowTask,
                errorApplist: errorApplist || [],
              }),
            );
          }
        }

        if (item.commandCode === '6') {
          if (item?.commandMsg?.appList && item?.commandMsg?.appList?.length > 0) {
            let textInfoArr = [''];
            let softArr = [];
            let errorApplist = [];
            item.commandMsg.appList.forEach(soft => {
              let flag = handleInstallSoft(soft);
              //1: 正常可以下载   2: 正在任务中  3:已安装  4:可更新  5:不支持下载  0:错误
              if (flag === 1 || flag === 4) {
                textInfoArr.push(`${soft.softName} 已为您添加到下载任务中。`);
                softArr.push(soft);
              }
              if (flag === 2) {
                textInfoArr.push(`检测到 ${soft.softName} 已在下载任务中。`);
                softArr.push(soft);
              }
              if (flag === 3) {
                textInfoArr.push(`您似乎已经安装了 ${soft.softName} 应用。`);
              }
              if (flag === 5) {
                softArr.push(soft);
                errorApplist.push(soft);
                // textInfoArr.push(`${soft.softName} 不支持直接下载安装。`);
              }
            });

            let textInfo = textInfoArr.join('');
            let isShowTask = 1;
            if (softArr?.length === 0) {
              isShowTask = 0;
            }
            dispatch(aigcReplyIsBusing({ isBusing: 1 }));
            dispatch(
              aigcReplyCommandEnd({
                ...aigcReplys,
                isCommandEnd: true,
                textInfo,
                isShowTask: isShowTask,
                errorApplist: errorApplist || [],
              }),
            );
          }
        }

        if (item.commandCode === '7') {
          if (item?.commandMsg?.appList && item?.commandMsg?.appList?.length > 0) {
            let textInfoArr = [''];
            let softArr = [];
            let errorApplist = [];
            item.commandMsg.appList.forEach(soft => {
              let oldSoft = installedSofts.find(item => {
                return item.SoftID === soft.softID;
              });
              let flag = handleInstallSoft(soft);

              //1: 正常可以下载   2: 正在任务中  3:已安装  4:可更新  5:不支持下载  0:错误
              if (flag === 1 || flag === 4) {
                if (oldSoft) {
                  textInfoArr.push(
                    ` ${soft.softName} 将从${oldSoft.displayVersion}版本更新到${soft.version}, 已为您添加到下载任务中。`,
                  );
                } else {
                  textInfoArr.push(
                    `您似乎没有安装 ${soft.softName} 应用, 已为您添加到下载任务中。`,
                  );
                }
                softArr.push(soft);
              } else if (flag === 2) {
                textInfoArr.push(`检测到 ${soft.softName} 已在下载任务中。`);
                softArr.push(soft);
              } else if (flag === 3) {
                textInfoArr.push(
                  ` ${soft.softName} 已是最新版本，当前没有可用的更新，您可以试试更新其它应用。`,
                );
              } else if (flag === 5) {
                softArr.push(soft);
                errorApplist.push(soft);
                // textInfoArr.push(`${soft.softName} 不支持直接下载安装。`);
              }
            });
            let textInfo = textInfoArr.join('');
            let isShowTask = 1;
            if (softArr?.length === 0) {
              isShowTask = 0;
            }
            dispatch(aigcReplyIsBusing({ isBusing: 1 }));
            dispatch(
              aigcReplyCommandEnd({
                ...aigcReplys,
                isCommandEnd: true,
                textInfo,
                isShowTask,
                errorApplist: errorApplist || [],
              }),
            );
          }
        }
        if (item.commandCode === '8') {
          let isShowTask = 0;
          let textInfo = '您似乎没有可更新的应用。';
          if (upgradeSofts && upgradeSofts?.length > 0) {
            let textInfoArr = [];
            upgradeSofts.forEach(soft => {
              let flag = handleInstallSoft(soft);
              if (flag === 1 || flag === 4) {
                textInfoArr.push(soft.softName);
              }
              if (flag === 2) {
                textInfoArr.push(`${soft.softName}`);
              }
            });

            if (textInfoArr?.length > 0) {
              textInfo = `${textInfoArr.join('、')}，已经添加到下载任务中。`;
              isShowTask = 1;
            }
          } else {
            textInfo = '您似乎没有可更新的应用。';
            isShowTask = 0;
          }

          dispatch(aigcReplyIsBusing({ isBusing: 1 }));
          dispatch(
            aigcReplyCommandEnd({
              ...aigcReplys,
              isCommandEnd: true,
              textInfo,
              isShowTask: isShowTask,
            }),
          );
        }
      });
      AIGC_CommandEnd_timeID[aigcReplys?.timeId] = true;
    }
  }, [aigcReplys, upgradeSofts, installedSofts, logInfoData]);

  // 返回结果打桩
  useEffect(() => {
    if (
      aigcReplys &&
      aigcReplys?.replys &&
      aigcReplys?.replys?.length > 0 &&
      aigcReplys?.timeId &&
      !AIGC_CommandEnd_LogInfo_timeID[aigcReplys?.timeId]
    ) {
      if (aigcReplys?.replys?.length > 0) {
        aigcReplys.replys.forEach((item, index) => {
          // 打桩
          dispatch(
            logging({
              category: 'R',
              action: 'Search_Aigc_Result',
              label: '',
              param2: {
                source: `AIGC_${logInfoData.source}`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                search_word: aigcReplys?.userQuestion?.userText,
              },
              param3: item?.bizInfo,
            }),
          );
        });
      }
      AIGC_CommandEnd_LogInfo_timeID[aigcReplys?.timeId] = true;
    }
  }, [aigcReplys]);
  // 处理需要去获取相关问题
  // useEffect(() => {
  //   if (
  //     aigcReplys?.question &&
  //     (!aigcRecoQuestion.question || aigcRecoQuestion.question !== aigcReplys.question) &&
  //     (!aigcRecoQuestion.timeId || aigcRecoQuestion.timeId !== aigcReplys.timeId)
  //   ) {
  //     dispatch(
  //       aigcGetQuestion({
  //         question: aigcReplys?.question,
  //         timeId: aigcReplys.timeId,
  //       }),
  //     );
  //   }
  // }, [aigcReplys, aigcRecoQuestion]);

  // 查询当前是否已经安装
  const checkIsUpdate = useCallback(
    soft => {
      if (upgradeSofts && upgradeSofts.length > 0) {
        return upgradeSofts.find(
          soft_ =>
            soft_.androidType !== '1' &&
            (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
        );
      }
      return null;
    },
    [upgradeSofts],
  );

  // 查询当前是否已经安装 并且是否可升级
  const checkIsInstalled = useCallback(
    soft => {
      if (installedSofts && installedSofts.length > 0) {
        return installedSofts.find(
          soft_ =>
            soft_.androidType !== '1' &&
            (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
        );
      }
      return null;
    },
    [downloadSofts],
  );

  // 查询当前是否处于安装列表
  const checkIsDownloading = useCallback(
    soft => {
      if (downloadSofts && downloadSofts.length > 0) {
        return downloadSofts.find(
          soft_ =>
            soft_.type === 'pc' &&
            (soft_.pc.SoftID === soft.softID ||
              soft_.pc.SoftID === soft.SoftID ||
              soft_.pc.SoftID === soft.softId),
        );
      }
      return null;
    },
    [installedSofts],
  );

  // 查询是否打开静默安装的开关
  // 查询当前是否属于静默安装
  const checkIsSilent = useCallback(
    soft => {
      if (silentInstSoft && isEnabledSilent) {
        return silentInstSoft.find(soft_ => soft_.softID === soft.softID);
      }
      return null;
    },
    [silentInstSoft, isEnabledSilent],
  );

  /**
   * 点击按钮处理
   * return 1: 正常可以下载   2: 正在任务中  3:已安装  4:可更新  5:不支持下载  0:错误
   */
  const handleInstallSoft = useCallback(
    softInfo => {
      if (!softInfo.softID) {
        return 0;
      }

      const downloading = checkIsDownloading(softInfo);
      const upgrade = checkIsUpdate(softInfo);
      const installed = checkIsInstalled(softInfo);
      const silentSoft = checkIsSilent(softInfo);

      const logParam2 = getLogParam2(softInfo, upgrade);
      // 获取静默安装参数
      let installparams = null;
      if (silentSoft && silentSoft.softID === softInfo.softID) {
        installparams = {};
        logParam2.type = upgrade ? 'xu' : 'xd';
        if (silentSoft.silentParamDic) {
          installparams.quiet = silentSoft.silentParamDic;
        }
        if (silentSoft.silentDirParamDic) {
          installparams.todir = silentSoft.silentDirParamDic;
        }
      }

      const softInfo_ = {
        ...softInfo,
        logInfo: logParam2,
        installparams,
        isClick: 'click_Ai_command',
      };

      // return的值 1: 正常可以下载   2: 正在任务中  3:已安装  4:可更新  5:不支持下载  0:错误
      if (downloading) {
        // 正在任务中
        return 2;
      } else if (!upgrade && installed) {
        // 已安装
        return 3;
      } else if (
        softInfo?.payType === 1 ||
        softInfo.appBizType === 1 ||
        softInfo.appBizType === 2 ||
        softInfo.androidType === '3'
      ) {
        // 不支持安装
        return 5;
      } else if (upgrade) {
        // 可更新
        dispatch(downloadAddSoft(softInfo_));
        return 4;
      } else if (!upgrade || !installed) {
        // 未安装
        dispatch(downloadAddSoft(softInfo_));
        return 1;
      }
      return 1;
    },
    [dispatch, upgradeSofts, installedSofts, logInfoData],
  );

  // 获取生成打桩参数
  const getLogParam2 = useCallback(
    (softInfo, upgrade) => {
      const logParam2 = {
        source: `AIGC_${logInfoData.source}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID,
        softName: softInfo.softName,
        softType: '0', // 安卓(1) 还是PC(0)应用
        type: upgrade ? 'u' : 'd', // 更新还是下载
        url: softInfo.downLoadUrl,
      };
      // search_type 1: 热词  2: 联想词  3: 搜索词  4: 联想词 首位应用  5: 热词应用  6: 联想词 非首位应用 10: AI来源
      logParam2.search_type = '10';
      logParam2.search_word = aigcReplys?.userQuestion?.userText;
      return logParam2;
    },
    [logInfoData],
  );

  return '';
});
